import { render, staticRenderFns } from "./coffee-card-list-home.vue?vue&type=template&id=3f2af971&"
import script from "./coffee-card-list-home.vue?vue&type=script&lang=js&"
export * from "./coffee-card-list-home.vue?vue&type=script&lang=js&"
import style0 from "./coffee-card-list-home.vue?vue&type=style&index=0&id=3f2af971&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports